module.exports = __webpack_public_path__ + "img/ESBE_1508.d8101611.png";